<app-form-field
  [formGroup]="form"
  [showError]="(submitted || form.controls.link.touched) && form.controls.link.invalid"
>
  <label class="!text-[14px]" app-label translate>trilhas.estudio.trilha.anexo-principal</label>
  <input app-input type="url" formControlName="link" (change)="onSend()" [placeholder]="'trilhas.link' | translate" />
</app-form-field>
